<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Shortcut Obat dan Alkes'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'medicine-packages'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/medicine-packages/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
       package_name:"",
       action_id:"",
       medicines:""
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Shortcut Obat dan Alkes", route: "" },
      { title: "Daftar Shortcut Obat dan Alkes", route: "/medicine-packages/list" },
      { title: "Tambah" },
    ])
  },

}

</script>